import React from 'react';
export default function WelcomeScreen({ onSelectQuestion, questions = [] }) {
  const starters = questions.filter((question) => question.isRecommended).slice(0, 6);
  return (
    <div className="welcome">
      <div className="welcome__badge">ChemRobotics AI</div>
      <h1 className="welcome__title">Pharma &amp; Agrochemical Intelligence Assistant</h1>
      <p className="welcome__sub">
        Ask about off-patent dates, India &amp; global approvals, molecule profiles and
        competitive intelligence. Start typing to see matching questions, or pick one below.
      </p>

      <div className="welcome__grid">
        {starters.map((s) => (
          <button
            key={s.id}
            className="starter-card"
            onClick={() => onSelectQuestion(s)}
          >
            <span className="starter-card__cat">{s.categoryName}</span>
            <span className="starter-card__q">{s.displayQuestion}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
